var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-input',{attrs:{"value":_vm.job.notes,"filled":"","type":"textarea","label":"Notes"},on:{"input":_vm.formUpdated}})
}
var staticRenderFns = []

export { render, staticRenderFns }